import { IJobsDownloadTemplate } from 'wisestep-api';

export type JobFields =
  | 'title'
  | 'jobCode'
  | 'locations'
  | 'description'
  | 'compensation'
  | 'jobType'
  | 'jobStatus'
  | 'createdOn'
  | 'updatedOn'
  | 'CreatedBy'
  | 'updatedBy'
  | 'remoteJob'
  | 'skills'
  | 'companyName'
  | 'clientRecruiterName'
  | 'tags'
  | 'clientJobCode'
  | 'numberOfPositions'
  | 'accountManagerName'
  | 'jobInsights'
  | 'jobIndustryName'
  | 'jobOccupation'
  | 'jobCategory'
  | 'workAuthorization'
  | 'url'
  | 'otherBenefitsDetails'
  | 'jobSource'
  | 'visaRequirements'
  | 'qualifications'
  | 'educationRequirements'
  | 'experienceRequirements'
  | 'taxTerms'
  | 'hiringFor'
  | 'workDuration'
  | 'defaultCurrency';
export const jobFieldsArray: JobFields[] = [
  'title',
  'jobCode',
  'locations',
  'description',
  'compensation',
  'jobType',
  'jobStatus',
  'createdOn',
  'updatedOn',
  'CreatedBy',
  'updatedBy',
  'remoteJob',
  'skills',
  'companyName',
  'clientRecruiterName',
  'tags',
  'clientJobCode',
  'numberOfPositions',
  'accountManagerName',
  'jobInsights',
  'jobIndustryName',
  'jobOccupation',
  'jobCategory',
  'workAuthorization',
  'url',
  'otherBenefitsDetails',
  'jobSource',
  'visaRequirements',
  'qualifications',
  'educationRequirements',
  'experienceRequirements',
  'taxTerms',
  'hiringFor',
  'workDuration',
  'defaultCurrency',
];

export const defValues: IJobsDownloadTemplate = {
  id: '',
  dataType: 'CRM',
  recruiterId: '',
  workspaceId: '',
  allowedColumns: [],
  isAdmin: false,
  recordsDownloadLimit: 2000,
  downloadCcEmail: '',
  name: '',
  isFavorite: false,
  isHidden: false,
};

export const jobsFieldsObj = {
  title: true,
  jobCode: true,
  locations: true,
  description: true,
  compensation: false,
  jobType: true,
  jobStatus: false,
  createdOn: false,
  updatedOn: false,
  CreatedBy: false,
  updatedBy: false,
  remoteJob: false,
  skills: false,
  companyName: false,
  clientRecruiterName: false,
  tags: false,
  clientJobCode: false,
  numberOfPositions: false,
  accountManagerName: false,
  jobInsights: false,
  jobIndustryName: false,
  jobOccupation: false,
  jobCategory: false,
  workAuthorization: false,
  url: false,
  otherBenefitsDetails: false,
  jobSource: false,
  visaRequirements: false,
  qualifications: false,
  educationRequirements: false,
  experienceRequirements: false,
  taxTerms: false,
  hiringFor: false,
  workDuration: false,
  defaultCurrency: false,
};
